@if (snackbar.state(); as t) {
  <div
    [ngClass]="['app-snackbar', 'app-snackbar--' + t.variant]"
    (mouseenter)="snackbar.pause()"
    (mouseleave)="snackbar.resume()"
    [attr.role]="hostRole(t.variant)"
    [attr.aria-live]="hostAriaLive(t.variant)"
    [style.--snackbar-duration]="t.duration + 'ms'"
  >
    @if (t.duration > 0) {
      <span class="app-snackbar__shade" aria-hidden="true"></span>
    }

    <span class="app-snackbar__icon-badge" aria-hidden="true">
      @switch (t.variant) {
        @case ('success') {
          <mat-icon class="app-snackbar__glyph-icon">check</mat-icon>
        }
        @case ('error') {
          <span class="app-snackbar__glyph-exclaim">!</span>
        }
        @case ('warning') {
          <mat-icon class="app-snackbar__glyph-icon">warning</mat-icon>
        }
        @default {
          <span class="app-snackbar__glyph-info">i</span>
        }
      }
    </span>

    <div class="app-snackbar__text">
      @if (t.title) {
        <div class="app-snackbar__title">{{ t.title }}</div>
      }
      <p class="app-snackbar__message">{{ t.message }}</p>
    </div>

    <button
      type="button"
      (click)="snackbar.dismiss()"
      class="app-snackbar__close"
      aria-label="Close notification"
    >
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>
}
